import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type OrganizationScrapedImageState = {
  organizationScrapedImagesById: { [organizationScrapedImageId: number]: OrganizationScrapedImage };
  organizationScrapedImagesStateByOrgId: StateDictionary;
};
type State = { organizationScrapedImages: OrganizationScrapedImageState };

const organizationScrapedImagesByIdSelector = (state: State) =>
  state.organizationScrapedImages.organizationScrapedImagesById;
const organizationScrapedImagesSelector = createSelector(
  [organizationScrapedImagesByIdSelector],
  (organizationScrapedImagesById) => Object.values(organizationScrapedImagesById),
);

export const organizationScrapedImageForOrgIdSelector = createSelector(
  [organizationScrapedImagesSelector, (_state: State, orgId: number) => orgId],
  (organizationScrapedImages, orgId) => organizationScrapedImages.filter((s) => s.orgId === orgId),
);

const organizationScrapedImagesStateByOrgIdSelector = (state: State) =>
  state.organizationScrapedImages.organizationScrapedImagesStateByOrgId;
export const organizationScrapedImagesStateForOrgIdSelector = createSelector(
  [organizationScrapedImagesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (organizationScrapedImagesStateByOrgId, orgId) => organizationScrapedImagesStateByOrgId[orgId],
);
